module.exports = __webpack_public_path__ + "static/media/dumpster.7c52ca9b.svg";